import React from "react";
import ReportHeader from "./ReportHeader";
import ReportFooter from "./ReportFooter";
import "./../../Styles/StylesReports.css";
import ReportMain from "./ReportMain";
import ReportTable from "./ReportTable";

import img2 from "./../../images/panjab-govt.jpg";
import ReportTable2 from "./ReportTable2";

export default function ReportLayout(props) {
  return (
    <>
      <div className="report-container position-relative">
        <img
          src={img2}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            transform: "scale(.7,.5)",
            zindex: "99",
            opacity: ".2"
          }}
          alt="GovT of Punjab"
        />
        <div style={{ width: "100%", height: "250px" }}>
          <ReportHeader />
        </div>
        <div
          style={{
            position: "absolute",
            zindex: "33",
            width: "100%",
            top: "150px",
            left: 0,
            backgroundColor: "transparent"
          }}
        >
          <ReportMain data={props.data} dataHeader={props.dataHeader} />
          <div className="row p-2">
            <div className="col-7 ">
              <ReportTable data={props.data} dataHeader={props.dataHeader} />
            </div>
            <div className="col-5 ">
              <ReportTable2 data={props.data} dataHeader={props.dataHeader} />
            </div>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            zindex: "-1",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "250px"
          }}
        >
          <ReportFooter />
        </div>
      </div>
      <div className="page-break p-0 m-0"> </div>
    </>
  );
}
